import styled, { css } from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  h1 {
    font-size: 100px !important;
    margin-bottom: -20px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 46px !important;
      line-height: 46px;
      margin-bottom: 0;
    }
  }
`;

export const GroupButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  gap: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 12px;
  }

  button {
    display: flex;
    align-items: center;
    border-radius: 20px;
    padding: 8px 24px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.white};

    ${({ $selected }) =>
      $selected === 'photo' &&
      css`
        &:nth-child(1) {
          background-color: rgba(256, 256, 256, 0.4);
        }
      `}

    ${({ $selected }) =>
      $selected === 'video' &&
      css`
        &:nth-child(2) {
          background-color: rgba(256, 256, 256, 0.4);
        }
      `}

    span {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 14px;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: rgba(256, 256, 256, 0.4);
    }
  }
`;

export const GroupUpload = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
  margin: 20px auto 0 auto;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    margin-top: 12px;
    gap: 4px;
  }

  > div {
    flex: 0 1 calc(33.333% - 8px);
    max-width: calc(33.333% - 8px);
    border-radius: 36px;

    @media ${({ theme }) => theme.devices.mobile} {
      border-radius: 20px;
      height: 140px;
    }
  }
`;
